import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "utils/store";
import { WheelState } from "./luckyWheel.api";

const selectLuckyWheelState = (state: RootState) => state.LuckyWheel;

type selectFestivalStateSelectorType = (state: RootState) => WheelState | undefined;
export const selectFestivalState: selectFestivalStateSelectorType = createSelector(
  [selectLuckyWheelState],
  (luckyWheelState) => luckyWheelState.festivalState
);
